module.exports = __webpack_public_path__ + "images/bailli-c7568a4a1cda60defb46edffa762fce6.jpg";